import React from 'react';

import {
	ItemsProviderContext,
	useItemsProviderContext,
	WithKey,
} from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import { BaseParams } from '@common/react/objects/BaseParams';

interface IProps<T extends WithKey, TFilters extends BaseParams = BaseParams> {
	title: React.ReactNode;
	inner?: (context: ItemsProviderContext<T, TFilters>) => JSX.Element;
	withoutItemsCount?: boolean;
	className?: string;
	children?: ((context: ItemsProviderContext<T, TFilters>) => JSX.Element) | React.ReactNode;
}

const TableTitle: <T extends WithKey, TFilters extends BaseParams = BaseParams>(
	p: IProps<T, TFilters>
) => React.ReactElement<T> = <T extends WithKey, TFilters extends BaseParams = BaseParams>(props: IProps<T, TFilters>) => {
	const {
		title,
		inner,
		withoutItemsCount = false,
		className = 'site-headline site-headline_with-button clearfix',
		children,
	} = props;
	const context = useItemsProviderContext<T, TFilters>();
	const pagination = context?.state?.pagination;

	return (
		<div className={className}>
			<span><h1 className="pull-left">{title}</h1></span>
			{!withoutItemsCount && pagination ? (
				<h1 className="pull-left">
					: #
					{pagination.total}
				</h1>
			) : ''}
			{typeof children !== 'undefined'
				? typeof children === 'function' ? children(context) : children
				: inner?.(context)}
		</div>
	);
};

export default TableTitle;
